import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const LanguageIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "LanguageIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.417 17.7671H4.58301C3.15869 17.7671 2 16.6084 2 15.1841V8.82666C2 7.40283 3.15869 6.24414 4.58301 6.24414H19.417C20.8413 6.24414 22 7.40283 22 8.82666V15.1841C22 16.6084 20.8413 17.7671 19.417 17.7671ZM4.58301 7.24414C3.70996 7.24414 3 7.9541 3 8.82666V15.1841C3 16.0571 3.70996 16.7671 4.58301 16.7671H19.417C20.29 16.7671 21 16.0571 21 15.1841V8.82666C21 7.9541 20.29 7.24414 19.417 7.24414H4.58301Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.96924 15.043C4.90039 15.043 4.83057 15.0288 4.76367 14.9985C4.51221 14.8848 4.40039 14.5884 4.51416 14.3369L6.76172 9.36573C6.84229 9.18751 7.01904 9.07276 7.21436 9.07178C7.43555 9.09961 7.5879 9.1836 7.67041 9.36084L9.98584 14.332C10.1025 14.582 9.99414 14.8794 9.74365 14.9961C9.49267 15.1123 9.1958 15.0039 9.07959 14.7539L7.22412 10.7705L5.42529 14.749C5.34179 14.9336 5.15967 15.043 4.96924 15.043Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.71533 13.4087H5.92334C5.64697 13.4087 5.42334 13.1851 5.42334 12.9087C5.42334 12.6323 5.64697 12.4087 5.92334 12.4087H8.71533C8.9917 12.4087 9.21533 12.6323 9.21533 12.9087C9.21533 13.1851 8.9917 13.4087 8.71533 13.4087Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.1577 11.0664H14.3472C14.0708 11.0664 13.8472 10.8428 13.8472 10.5664C13.8472 10.29 14.0708 10.0664 14.3472 10.0664H19.1577C19.4341 10.0664 19.6577 10.29 19.6577 10.5664C19.6577 10.8428 19.4341 11.0664 19.1577 11.0664Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.7524 11.0664C16.4761 11.0664 16.2524 10.8428 16.2524 10.5664V9.40528C16.2524 9.12891 16.4761 8.90528 16.7524 8.90528C17.0288 8.90528 17.2524 9.12891 17.2524 9.40528V10.5664C17.2524 10.8428 17.0288 11.0664 16.7524 11.0664Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.3091 15.043C15.1035 15.043 14.9111 14.9155 14.8384 14.7109C14.7451 14.4512 14.8809 14.165 15.1411 14.0723C17.3066 13.2988 17.6973 10.7852 17.7012 10.7598C17.7407 10.4868 17.9951 10.2905 18.2681 10.3374C18.541 10.377 18.7305 10.6309 18.6904 10.9043C18.6719 11.0317 18.2031 14.0405 15.477 15.0137C15.4219 15.0337 15.3647 15.043 15.3091 15.043Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.1958 15.043C18.1401 15.043 18.083 15.0337 18.0278 15.0137C16.8926 14.6084 15.9761 13.7671 15.3784 12.5811C15.2539 12.3345 15.353 12.0337 15.5996 11.9097C15.8457 11.7832 16.146 11.8843 16.271 12.1309C16.7583 13.0972 17.4624 13.75 18.3638 14.0723C18.624 14.165 18.7598 14.4512 18.6665 14.7109C18.5937 14.9155 18.4014 15.043 18.1958 15.043Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 17.7012C11.7236 17.7012 11.5 17.4775 11.5 17.2012V6.73291C11.5 6.45654 11.7236 6.23291 12 6.23291C12.2764 6.23291 12.5 6.45654 12.5 6.73291V17.2012C12.5 17.4775 12.2764 17.7012 12 17.7012Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default LanguageIcon;
